import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import PlatformLanding from "./components/PlatformLanding";
import Insights from "./components/Insights";
import InsightDetail from "./components/InsightDetail";
import DealerCity from "./components/DealerCity";
import Quote from "./components/Quote";
import UseCase from "./components/UseCase";
import { ProductsOverview, ProductFamily } from "./components/ProductFamily";
import { ProductSku } from "./components/ProductSku";
import { ProductsCompare } from "./components/ProductsCompare";
import CityMetro from "./components/CityMetro";
import { ALL_CITY_SLUGS } from "./data/cityCatalogue";
import WhatsappFab from "./components/WhatsappFab";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PlatformLanding />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/dealers/:city" element={<DealerCity />} />
          <Route path="/use-cases/:slug" element={<UseCase />} />
          <Route path="/products" element={<ProductsOverview />} />
          <Route path="/products/compare" element={<ProductsCompare />} />
          <Route path="/products/:family" element={<ProductFamily />} />
          <Route path="/products/:family/:sku" element={<ProductSku />} />
          <Route path="/quote" element={<Quote />} />
          {/* Metro SEO landing pages — long-tail "boom barrier {city}" keyword */}
          {ALL_CITY_SLUGS.map((s) => (
            <Route
              key={s}
              path={`/boom-barrier-${s}`}
              element={<CityMetro slug={s} />}
            />
          ))}
          {/* Legacy redirects so any old bookmarks land on the new canonical site */}
          <Route path="/platform" element={<Navigate to="/" replace />} />
          <Route path="/v2" element={<Navigate to="/" replace />} />
          <Route path="/legacy" element={<Navigate to="/" replace />} />
          <Route path="/themes" element={<Navigate to="/" replace />} />
          <Route path="/preview/optimized" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <WhatsappFab />
      </BrowserRouter>
    </div>
  );
}

export default App;
